import { FC } from "react";
import { isIneligibleLawFirm } from "../../eligibility/participantEligibilityRules";
import { NON_LAWYER_COMBINED_OWNER_SHARE_HELPER } from "../../eligibility/participantEligibilityUi";
import { IneligibleLawFirmNotice } from "./IneligibleLawFirmNotice";
import { LawyerOrLawFirmSelectField } from "./LawyerOrLawFirmSelectField";
import { LeavesOtherOnEntryField } from "./LeavesOtherOnEntryField";
import { OwnerAndVoteShareFields } from "./OwnerAndVoteShareFields";
import { PartnerExamEligibilityFields } from "./PartnerExamEligibilityFields";

type ChangeAdvokatselskabEnteringPartnerEligibilityFieldsProps = {
  namePrefix: string;
  idPrefix: string;
  isLawyerOrLawFirm: string;
  passedPartnerExam: string;
  leavesOtherOnEntry: string;
};

export const ChangeAdvokatselskabEnteringPartnerEligibilityFields: FC<
  ChangeAdvokatselskabEnteringPartnerEligibilityFieldsProps
> = ({
  namePrefix,
  idPrefix,
  isLawyerOrLawFirm,
  passedPartnerExam,
  leavesOtherOnEntry,
}) => (
  <div className="d-flex flex-column gap-4">
    <LawyerOrLawFirmSelectField
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      label="Er deltageren advokat eller et advokatselskab?"
    />
    {isIneligibleLawFirm(isLawyerOrLawFirm) && (
      <IneligibleLawFirmNotice title="Denne deltager kan ikke tilføjes" />
    )}
    <PartnerExamEligibilityFields
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      isLawyerOrLawFirm={isLawyerOrLawFirm}
      passedPartnerExam={passedPartnerExam}
      label="Har vedkommende bestået eller tilmeldt sig partnerprøven?"
      ineligibleTitle="Denne deltager kan ikke tilføjes"
    />
    <OwnerAndVoteShareFields
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      isLawyerOrLawFirm={isLawyerOrLawFirm}
      passedPartnerExam={passedPartnerExam}
      ownerShareHelperText={NON_LAWYER_COMBINED_OWNER_SHARE_HELPER}
    />
    <LeavesOtherOnEntryField
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      isLawyerOrLawFirm={isLawyerOrLawFirm}
      passedPartnerExam={passedPartnerExam}
      leavesOtherOnEntry={leavesOtherOnEntry}
      label="Ophører deltagerens tilknytning til en anden virksomhed samtidigt med indtræden i denne?"
      helperWhenJa="Udtræder selskabsdeltageren af en anden ejerkreds, skal pågældende selskab indsende en blanket vedrørende ændringen. Ophører en enkeltmandsvirksomhed ved nærværende ændring, skal CVR tilpasses. Læs om sluterklæringer på Advokatsamfundets hjemmeside."
    />
  </div>
);
